import React from 'react';
import Title from '../title/title.js';
import modules_1229886e from './live_modes_prices.module.scss.js';

const LiveModesPrices = ({ type, liveModeMinPrices, loading }) => {
    const { liveModeMinPrice, liveModeMinSalesPrice, liveModeFromText, liveModeMinPriceTitle, liveModeMinSalesPriceTitle, liveModeFromTextFontStyle, liveModeMinPriceTitleFontStyle, liveModeMinPriceCrosePriceFontStyle } = liveModeMinPrices;
    const getFontStyleForFromText = () => {
        if (liveModeFromTextFontStyle)
            return liveModeFromTextFontStyle;
        return "content-small";
    };
    const renderFromText = () => (React.createElement("div", { className: modules_1229886e["live-modes-prices-from-container"], "data-testid": "mbw-live-modes-prices-from-container" },
        React.createElement(Title, { fontStyle: getFontStyleForFromText(), loading: loading }, liveModeFromText)));
    const getFontStyleForCrosePrice = () => {
        if (liveModeMinPriceCrosePriceFontStyle)
            return liveModeMinPriceCrosePriceFontStyle;
        return "content-small";
    };
    const renderCrosePrice = () => {
        if (!liveModeMinSalesPrice)
            return null;
        return (React.createElement("div", { className: modules_1229886e["live-modes-prices-crose-price-container"], "data-testid": "mbw-live-modes-prices-crose-price-container" },
            React.createElement(Title, { fontStyle: getFontStyleForCrosePrice(), loading: loading }, `$${liveModeMinPrice}`)));
    };
    const getFontStyleForPrice = () => {
        if (liveModeMinPriceTitleFontStyle)
            return liveModeMinPriceTitleFontStyle;
        return "content-small";
    };
    const renderPrice = () => {
        let priceValue = liveModeMinPriceTitle;
        let priceClassName = modules_1229886e["live-modes-prices-price-container"];
        if (liveModeMinSalesPrice) {
            priceValue = liveModeMinSalesPriceTitle;
            priceClassName = modules_1229886e["live-modes-sales-prices-price-container"];
        }
        return (React.createElement("div", { className: priceClassName, "data-testid": "mbw-live-modes-prices-price-container" },
            React.createElement(Title, { fontStyle: getFontStyleForPrice(), bold: true, loading: loading }, priceValue)));
    };
    const renderLiveModesPrices = () => (React.createElement("div", { className: modules_1229886e[`live-modes-prices-${type}-container`], "data-testid": "mbw-live-modes-prices-container" },
        React.createElement("div", { className: modules_1229886e["live-modes-prices-from-and-crose-price-container"] },
            renderFromText(),
            renderCrosePrice()),
        React.createElement("div", null, renderPrice())));
    return renderLiveModesPrices();
};

export { LiveModesPrices as default };
//# sourceMappingURL=live_modes_prices.js.map
